import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { AppLink } from '@chegg-wt/core/components/AppLink'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { HOMEPAGE_CARD, TYPE_CHECK_PAPER } from '@chegg-wt/core/constants/card'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { Config } from '@chegg-wt/core/config'
import { AppRoute, CardType, Card } from '@chegg-wt/core/types/core'
import { navigated } from '@chegg-wt/core/state/app/actions'
import { routeToHref } from '@chegg-wt/core/utils/routes'
import * as Styled from './styled'

interface CardWithLinkProps {
  cardProps: Card
  route: AppRoute
  navigated: (route: AppRoute) => void
  onUserClickCTA: (type: CardType) => void
}

export const CardWithLink: React.FunctionComponent<CardWithLinkProps> = ({
  cardProps: { imgFilename, buttonText, context, dataTestId, type },
  route,
  navigated,
  onUserClickCTA,
}) => {
  const { value, contextTestId } = context

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    onUserClickCTA(type)
    if (Config.shouldOpenInNewTab && type === TYPE_CHECK_PAPER) {
      window.open(routeToHref(route))
    } else {
      navigated(route)
    }
  }
  return (
    <Styled.CardContainer>
      <Styled.IconContainer>
        <img
          width="100"
          height="100"
          alt={buttonText}
          src={publicAssetUrl(imgFilename)}
        />
      </Styled.IconContainer>
      <AppLink route={route}>
        <Styled.Button onClick={handleClick} data-test={dataTestId}>
          {buttonText}
        </Styled.Button>
      </AppLink>
      <Styled.Context data-test={contextTestId}>{value}</Styled.Context>
    </Styled.CardContainer>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  navigated: (route: AppRoute) => dispatch(navigated(route)),
  onUserClickCTA: (type: CardType) =>
    dispatch(userClick({ origin: `${HOMEPAGE_CARD}-${type}` as const })),
})

export default connect(null, mapDispatchToProps)(CardWithLink)
